import { SelectChangeEvent } from '@mui/material';
import { Control, FieldValues, Path } from 'react-hook-form';
import { StyleObj } from '../../@types';
import { Bet } from '../../@types/api';
import theme from '../../styles/theme';
import FormSelect from './FormSelect';
import { useSpecialValueReoffer } from '../../hooks/useSpecialValueReoffer';

const styles: StyleObj = {
  input: {
    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
    '& .MuiSelect-select': {
      fontSize: '0.875rem',
      fontWeight: 'bold',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.75rem',
      },
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
  },
};

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  bet: Bet;
  onSpecialValueChange: (
    selectedSpecialValueId: string,
    selectedSpecialValueMarketId: string,
    outcomeId: string,
    selectedOdds: string,
    name: string
  ) => void;
};

const TicketAuthSpecialValueSelect = <T extends FieldValues>({
  name,
  control,
  bet,
  onSpecialValueChange,
}: Props<T>) => {
  const { options, getOutcomeDetailsById, isLoading } = useSpecialValueReoffer({ bet });

  const handleChange = (e: SelectChangeEvent<unknown>) => {
    const selectedOutcomeId = e.target.value as string;
    const { odds, name, marketId } = getOutcomeDetailsById(selectedOutcomeId);
    onSpecialValueChange(selectedOutcomeId, marketId, bet.id, odds, name);
  };

  if (isLoading) {
    return null;
  }

  return (
    <FormSelect
      control={control}
      name={name}
      size='small'
      options={options}
      sx={styles.input}
      onChange={handleChange}
      MenuProps={{
        slotProps: {
          paper: {
            sx: {
              '& .MuiMenuItem-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '0.75rem',
                },
              },
            },
          },
        },
      }}
    />
  );
};

export default TicketAuthSpecialValueSelect;
